import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SearchBar, Pagination } from "../../components";
import { closeModal } from "../../store/slices/deleteModalSlice";
import { openModal } from "../../store/slices/editModalCardsSlice";
import { openModalDelete } from "../../store/slices/deleteModalCardsSlice";
import AddModalCards from "../Modals/AddModalCards";
import { getAllCards, setPage } from "../../store/slices/debtSlice";
import EditModalCards from "../Modals/EditModal/EditModalCards";
import DeleteModalCards from "../Modals/DeleteModal/DeleteModalCards";
import { fetchDataCard } from "../../store/slices/apiCardSlice";

const TableCards = () => {
  const dispatch = useDispatch();
  const totalCards = useSelector((state) => state.debt.cards);
  const currentPage = useSelector((state) => state.debt.currentPage);
  const [searchInput, setSearchInput] = useState("");
  const editModalState = useSelector((state) => state.editModalCards);
  const prevSearchRef = useRef("");

  useEffect(() => {
    const pageToUse =
      prevSearchRef.current !== searchInput ? 1 : currentPage;
  
    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1)); // Reset page in Redux
      prevSearchRef.current = searchInput;
    }
  
    dispatch(getAllCards({ page: pageToUse, searchQuery: searchInput }));
  }, [dispatch, currentPage, searchInput]);
  

  const refreshCards = () => {
    dispatch(getAllCards({ page: currentPage, searchQuery: searchInput }));
  };

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(getAllCards({ page: currentPage, searchQuery: searchInput }));
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  useEffect(() => {
    dispatch(fetchDataCard());
  }, [dispatch]);

  const handleEditItem = (id) => {
    dispatch(openModal(id));
  };

  const handleDeleteItem = (id) => {
    dispatch(openModalDelete(id));
  };

  const refreshData = () => {
    dispatch(fetchDataCard());
  };

  return (
    <div className="p-3">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pb-4 bg-white dark:bg-gray-900">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />
        <div>
          <button className="text-blue-500">
            <AddModalCards
              title="Shto Kodin"
              submitButtonText="Shto Kodin"
              onCancel={handleCloseModal}
              namePackage="Kodi"
              packageCategory="Zgjedh kategorinë"
              priceValue="Cmimi i karteles"
              days="Ditet"
              onCardCreated={refreshCards}
            />
          </button>
        </div>
      </div>

      <div className="relative overflow-x-auto shadow-md sm:rounded-lg border border-gray-200 dark:border-gray-700">
        <div className="hidden sm:block">
          <table className="min-w-full text-xs sm:text-sm text-left text-gray-600 dark:text-gray-300">
            <thead className="text-xs uppercase bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300">
              <tr>
                <th scope="col" className="px-3 py-1 whitespace-nowrap">
                  Kodi
                </th>
                <th scope="col" className="px-3 py-2  whitespace-nowrap">
                  Kategoria
                </th>
                <th scope="col" className="px-3py-2  whitespace-nowrap">
                  Autoshkolla
                </th>
                <th scope="col" className="px-3 py-2  whitespace-nowrap">
                  Qmimi i adminit
                </th>
                <th scope="col" className="px-3 py-2  whitespace-nowrap">
                  Qmimi i autoshkolles
                </th>
                <th scope="col" className="px-3py-2  whitespace-nowrap">
                  Statusi i Karteles
                </th>
                <th scope="col" className="px-3 py-2  whitespace-nowrap">
                  Ditet
                </th>
                <th scope="col" className="px-3 py-2  whitespace-nowrap">
                  Aksionet
                </th>
              </tr>
            </thead>
            <tbody>
              {totalCards?.data?.map((item) => (
                <tr
                  key={item.id}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    {item.code}
                  </td>
                  <td className="px-6 py-4">{item.categoryName}</td>
                  <td className="px-6 py-4">{item.schoolName}</td>
                  <td className="px-6 py-4">{item.adminPrice}.00 € </td>
                  <td className="px-6 py-4">{item.schoolPrice}.00 € </td>
                  <td className="px-4 py-3 break-words">
                    {item.status === 0
                      ? "Pa aktivizuar"
                      : item.status === 1
                      ? "Aktivizuar"
                      : "Skaduar"}
                  </td>
                  <td className="px-6 py-4">{item.days}</td>
                  <td className="px-6 py-4 w-40 flex ">
                    <button
                      className="text-success mx-1"
                      onClick={() => handleEditItem(item.id)}
                    ></button>

                    <EditModalCards
                      id={item.id}
                      title="Edito Një Kartele"
                      submitButtonText="Edito kartelen"
                      packageCategory="Lloji i kategorisë"
                      days="Ditet e abonimit"
                      isOpen={editModalState[item.id] === true}
                      onUpdate={refreshData}
                    />

                    <button
                      className="text-danger mx-1"
                      onClick={() => handleDeleteItem(item.id)}
                    >
                      <DeleteModalCards id={item.id} onDeleted={refreshData} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="block sm:hidden space-y-4">
          {totalCards?.data?.map((item) => (
            <div
              key={item.id}
              className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
            >
              <p>
                <strong>Kodi:</strong> {item.code}
              </p>
              <p>
                <strong>Kategoria:</strong> {item.categoryName}
              </p>
              <p>
                <strong>Autoshkolla:</strong> {item.driveSchoolName}
              </p>
              <p>
                <strong>Qmimi i adminit:</strong> {item.adminPrice}.00 €
              </p>
              <p>
                <strong>Qmimi i autoshkolles:</strong> {item.schoolPrice}.00 €
              </p>
              <p>
                <strong>Statusi i Karteles:</strong>{" "}
                {item.status === 0
                  ? "Pa aktivizuar"
                  : item.status === 1
                  ? "Aktivizuar"
                  : "Skaduar"}
              </p>
              <p>
                <strong>Ditet:</strong> {item.days}
              </p>

              <div className="flex gap-2">
                <button
                  className="text-success"
                  onClick={() => handleEditItem(item.id)}
                ></button>
                <EditModalCards
                  id={item.id}
                  title="Edito Një Kartele"
                  submitButtonText="Edito kartelen"
                  packageCategory="Lloji i kategorisë"
                  days="Ditet e abonimit"
                  isOpen={editModalState[item.id] === true}
                  onUpdate={refreshData}
                />
                <button
                  className="text-danger"
                  onClick={() => handleDeleteItem(item.id)}
                >
                  <DeleteModalCards id={item.id} onDeleted={refreshData} />
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="p-4">
          <Pagination
            currentPage={currentPage}
            totalCount={totalCards?.totalCount || 0}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default TableCards;
